import React, { useEffect, useState } from 'react';
import { DataEntryDatePicker, } from '../CustomStyles/StyledComponents';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Paper, TextField } from '@mui/material';
import dayjs from 'dayjs';

const TableSearchDatePicker =({ inputFormat = 'DD-MM-YY',
                                outputFormat = 'YYYY-MM-DD',
                                views = undefined,
                                searchKey,
                                handleSearchQuery = () => { },
                                ...otherProps }) => 
    {
        const [searchDateFrom, setSearchDateFrom] = useState(undefined);
        const [searchDateTo, setSearchDateTo] = useState(undefined);

        useEffect(() => {
            handleSearchQuery(searchKey.concat('From'), searchDateFrom?.isValid() ? dayjs((searchDateFrom)?.toISOString()).format(outputFormat) : '');
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [searchDateFrom]);

        useEffect(() => {
            handleSearchQuery(searchKey.concat('To'), searchDateTo?.isValid() ? dayjs(searchDateTo?.toISOString()).format(outputFormat) : '');
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [searchDateTo]);

        let ariaLabel = otherProps['aria-label']
        if(!ariaLabel){
            ariaLabel = 'Date picker'
        }
        otherProps['aria-label']=null
        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Paper p={0} m={0} >
                    <DataEntryDatePicker
                        openTo="day"
                        format={inputFormat}
                        views={views}
                        value={searchDateFrom || null}
                        maxDate={searchDateTo || null}
                        onChange={setSearchDateFrom}
                        slotProps={{
                            field: { clearable: true},
                            textField: (params) => ({
                                inputProps: {
                                    ...params.inputProps,
                                    placeholder: "From",
                                    "aria-label":`${ariaLabel} From`
                                }
                            })
                        }}
                        {...otherProps}
                    />

                    <DataEntryDatePicker
                        openTo="day"
                        format={inputFormat}
                        views={views}
                        value={searchDateTo || null}
                        minDate={searchDateFrom || null}
                        onChange={setSearchDateTo}
                        slotProps={{
                            field: { clearable: true},
                            textField: (params) => ({
                                inputProps: {
                                    ...params.inputProps,
                                    placeholder: "To",
                                    "aria-label": `${ariaLabel} To`
                                }
                            })
                        }}
                        {...otherProps}
                    />
                </Paper>
            </LocalizationProvider >
        );
    };

export default TableSearchDatePicker;

